export default __webpack_public_path__ + "static/media/seat-icon.93e58925.svg";